import { render, staticRenderFns } from "./FilterBarProviderSeo.vue?vue&type=template&id=3606dce8"
import script from "./FilterBarProviderSeo.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterBarProviderSeo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FilterBarProviderSeo.vue?vue&type=style&index=0&id=3606dce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports